/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Msg_About_Photo_UpdatedInputs */

const en_msg_about_photo_updated = /** @type {(inputs: Msg_About_Photo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About page photo updated`)
};

const es_msg_about_photo_updated = /** @type {(inputs: Msg_About_Photo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto de la página 'Acerca de' actualizada`)
};

const fr_msg_about_photo_updated = /** @type {(inputs: Msg_About_Photo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo de la page À propos mise à jour`)
};

const de_msg_about_photo_updated = /** @type {(inputs: Msg_About_Photo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto der Über-uns-Seite aktualisiert`)
};

const id_msg_about_photo_updated = /** @type {(inputs: Msg_About_Photo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto halaman tentang telah diperbarui`)
};

/** @type {(inputs: Msg_About_Photo_UpdatedInputs) => LocalizedString} */
const ja_msg_about_photo_updated = en_msg_about_photo_updated;

/** @type {(inputs: Msg_About_Photo_UpdatedInputs) => LocalizedString} */
const zh_msg_about_photo_updated = en_msg_about_photo_updated;

/** @type {(inputs: Msg_About_Photo_UpdatedInputs) => LocalizedString} */
const ar_msg_about_photo_updated = en_msg_about_photo_updated;

/** @type {(inputs: Msg_About_Photo_UpdatedInputs) => LocalizedString} */
const it_msg_about_photo_updated = en_msg_about_photo_updated;

/** @type {(inputs: Msg_About_Photo_UpdatedInputs) => LocalizedString} */
const ru_msg_about_photo_updated = en_msg_about_photo_updated;

/** @type {(inputs: Msg_About_Photo_UpdatedInputs) => LocalizedString} */
const pt_msg_about_photo_updated = en_msg_about_photo_updated;

/** @type {(inputs: Msg_About_Photo_UpdatedInputs) => LocalizedString} */
const ko_msg_about_photo_updated = en_msg_about_photo_updated;

/**
* | output |
* | --- |
* | "About page photo updated" |
*
* @param {Msg_About_Photo_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const msg_about_photo_updated = /** @type {((inputs?: Msg_About_Photo_UpdatedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Msg_About_Photo_UpdatedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_msg_about_photo_updated(inputs)
	if (locale === "es") return es_msg_about_photo_updated(inputs)
	if (locale === "fr") return fr_msg_about_photo_updated(inputs)
	if (locale === "de") return de_msg_about_photo_updated(inputs)
	if (locale === "ja") return ja_msg_about_photo_updated(inputs)
	if (locale === "zh") return zh_msg_about_photo_updated(inputs)
	if (locale === "ar") return ar_msg_about_photo_updated(inputs)
	if (locale === "id") return id_msg_about_photo_updated(inputs)
	if (locale === "it") return it_msg_about_photo_updated(inputs)
	if (locale === "ru") return ru_msg_about_photo_updated(inputs)
	if (locale === "pt") return pt_msg_about_photo_updated(inputs)
	return ko_msg_about_photo_updated(inputs)
});